import { MatLabel } from '@angular/material/form-field';
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UserService } from "src/app/user/user.service";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatFormField, MatInput } from "@angular/material/input";
import { MgFormControlDirective } from "@mango/core";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";

@Component({
    selector: 'suselbeek-forgot-password-dialog',
    templateUrl: 'forgot-password-dialog.component.html',
    styleUrls: ['forgot-password-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, MgFormControlDirective, MatIcon, MatDialogActions, MatButton]
})
export class ForgotPasswordDialogComponent {

    status: String;

    form = new UntypedFormGroup({
        email: new UntypedFormControl('', [Validators.required, Validators.email])
    });

    constructor(public dialogRef: MatDialogRef<ForgotPasswordDialogComponent>, public snackBar: MatSnackBar, public userService: UserService) {

    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    async onSubmit() {
        let result = this.form.get('email').value;

        if (result) {
            try {
                let response = await this.userService.sendForgotPassword(result).toPromise();
                if (response) {
                    this.snackBar.open(`Er is een e-mail verzonden naar ${result} met informatie over het veranderen van het wachtwoord.`, 'OK', {
                        duration: 2000
                    });
                    this.dialogRef.close();
                }
                else {
                    this.status = 'Er is een fout opgetreden, controleer of het e-mail adres bestaat en probeer het opnieuw.';
                }
            }
            catch (err)
            {
                console.log(err);
                this.status = err?.error?.message || 'Er is een fout opgetreden, controleer of het e-mail adres bestaat en probeer het opnieuw.';
            }
            
        }


    }

}